module.exports = __webpack_public_path__ + "img/background22.66810964.jpg";